import { LoadingOutlined } from '@ant-design/icons'
import { Flex, Row, Spin } from 'antd'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import dashboardApi from '../../api/dashboard.api'
import { userState } from '../../store/user'
import '../../styles/home.scss'

const InquiryDashboard = () => {
  const navigate = useNavigate()
  const [user, setUser] = useRecoilState(userState)
  const [isLoading, setIsLoading] = useState(true)
  const [inquiryInfo, setInquiryInfo] = useState({
    total: 0, // 전체
    use: 0, // 이용방법
    error: 0, // 기능오류
    other: 0, // 기타문의
    product: 0, // 상품문의
  })

  useEffect(() => {
    getUnansweredInquiry()
  }, [])

  const getUnansweredInquiry = async () => {
    setIsLoading(true)
    try {
      const param = {
        userId: user.id,
      }
      const res = await dashboardApi.getInquiryStatistics(param)
      // console.log('res', res)
      if (res.data.code === 200) {
        setInquiryInfo({
          total: res.data.result.total_count,
          use: res.data.result.use_count,
          error: res.data.result.error_count,
          other: res.data.result.other_count,
          product: res.data.result.productQuestionList ?? 0,
          trial: res.data.result.trialCount,
        })
      }
    } catch (e) {
      console.log('InquiryDashboard :: getUnansweredInquiry error = ', e)
      setInquiryInfo({
        total: 0,
        use: 0,
        error: 0,
        other: 0,
      })
    } finally {
      setIsLoading(false)
    }
  }

  const listTitle = (key) => {
    if (key === 'total') {
      return '전체'
    } else if (key === 'use') {
      return '이용방법'
    } else if (key === 'error') {
      return '기능오류'
    } else if (key === 'other') {
      return '기타문의'
    } else if (key === 'product') {
      return '상품문의'
    } else if (key === 'trial') {
      return '체험단문의'
    }
  }

  return (
    <Flex
      vertical
      style={{ minWidth: '280px', height: '100%' }}
      className={`home-dashboard-component dash-cursor ${isLoading ? 'container-disable' : ''}`}
      onClick={() => navigate('/inquiry/list')}
    >
      {isLoading && (
        <Spin
          className={'home-dashboard-loading'}
          indicator={<LoadingOutlined spin />}
          size={'large'}
        />
      )}
      <Flex align={'center'} gap={4} className={'home-dashboard-title'}>
        <h2>미답변문의</h2>
        <p className={'title-info-text'}>30일 기준</p>
      </Flex>
      <Flex
        vertical
        justify={'start'}
        gap={20}
        className={'inquiry-list-wrap'}
        style={{ paddingBottom: '12px' }}
      >
        {Object.keys(inquiryInfo).map((key, idx) => (
          <Row
            key={`inquiry-list-${idx}`}
            className={'inquiry-list-div'}
            style={{ justifyContent: 'space-between', display: 'flex' }}
          >
            <p>{listTitle(key)}</p>
            <div className={'inquiry-list-count-div'}>
              <p>{inquiryInfo[key]?.toLocaleString()} 건</p>
            </div>
          </Row>
        ))}
      </Flex>
    </Flex>
  )
}

export default InquiryDashboard
